import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import FormatStrikethroughIcon from '@mui/icons-material/FormatStrikethrough';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const AlignmentText = ({ selectedShape, handleChangeProperty }) => {
    const { t } = useTranslation();

    if (selectedShape?.property !== 'texts') return null;

    return (
        <div className='mt-3'>
            <h4 className='mb-3 title-property'>{t('alignment')}</h4>

            <div className='d-flex'>
                <ButtonGroup variant='text' aria-label='text button group'>
                    <Button
                        id='btn_ct_aling'
                        className={`shadow-none ${selectedShape?.align.includes('left') ? 'active-button' : ''}`}
                        onClick={() => handleChangeProperty('align', 'left')}
                    >
                        <FormatAlignLeftIcon className='hover-white-icon' />
                    </Button>
                    <Button
                        className={`shadow-none ${selectedShape?.align.includes('center') ? 'active-button' : ''}`}
                        onClick={() => handleChangeProperty('align', 'center')}
                    >
                        <FormatAlignCenterIcon className='hover-white-icon' />
                    </Button>
                    <Button
                        className={`shadow-none ${selectedShape?.align.includes('right') ? 'active-button' : ''}`}
                        onClick={() => handleChangeProperty('align', 'right')}
                    >
                        <FormatAlignRightIcon className='hover-white-icon' />
                    </Button>
                </ButtonGroup>

                <ButtonGroup variant='text' aria-label='text button group'>
                    <Button
                        className={`shadow-none ${selectedShape?.fontStyle.includes('bold') ? 'active-button' : ''}`}
                        onClick={() => handleChangeProperty('fontStyle', 'bold')}
                    >
                        <FormatBoldIcon className='hover-white-icon' />
                    </Button>
                    <Button
                        className={`shadow-none ${selectedShape?.fontStyle.includes('italic') ? 'active-button' : ''}`}
                        onClick={() => handleChangeProperty('fontStyle', 'italic')}
                    >
                        <FormatItalicIcon className='hover-white-icon' />
                    </Button>
                </ButtonGroup>
            </div>

            <div className='mt-3'>
                <ButtonGroup variant='text' aria-label='text button group'>
                    <Button
                        className={`shadow-none ${
                            selectedShape?.textDecoration.includes('underline') ? 'active-button' : ''
                        }`}
                        onClick={() => handleChangeProperty('textDecoration', 'underline')}
                    >
                        <FormatUnderlinedIcon className='hover-white-icon' />
                    </Button>
                    <Button
                        className={`shadow-none ${
                            selectedShape?.textDecoration.includes('line-through') ? 'active-button' : ''
                        }`}
                        onClick={() => handleChangeProperty('textDecoration', 'line-through')}
                    >
                        <FormatStrikethroughIcon className='hover-white-icon' />
                    </Button>
                </ButtonGroup>
            </div>
        </div>
    );
};

export default AlignmentText;
